import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface SideModalHeaderProps {
  title: string;
  onClose: () => void;
}

export const SideModalHeader = ({ title, onClose }: SideModalHeaderProps) => {
  return (
    <Paper variant="sideModalHeader">
      <Typography variant="title.step" className="SideModalHeader-title">
        {title}
      </Typography>
      <IconButton onClick={onClose} aria-label="close">
        <CloseIcon className="SideModalHeader-closeIcon" />
      </IconButton>
    </Paper>
  );
};
